import { atom } from 'jotai';

import { AgentStatusEnum, SoftphoneConnectionBehaviorEnum } from '@lib/enums';

import type { CallDirectionEnum, ChannelEnum, SoftphoneIntegrationEnum } from '@lib/enums';

export type TSoftphoneConfig = Readonly<{
  client: SoftphoneIntegrationEnum;
  enabled: boolean;
  enableDebugLogs: boolean;
}>;

export type TSoftphoneState = Readonly<{
  agentStatus: AgentStatusEnum;
  callDirection: Nullable<CallDirectionEnum>;
  channel: Nullable<ChannelEnum>;
  connectionBehavior: Nullable<SoftphoneConnectionBehaviorEnum>;
  contactId: Nullable<string>;
  contactMasterId: Nullable<string>;
  contactPhoneNumber: Nullable<string>;
  leadId: Nullable<string>;
  isDialerReturn: Nullable<boolean>;
  isInternetResponder: Nullable<boolean>;
  isTvResponder: Nullable<boolean>;
  isSpanishSkillActive: Nullable<boolean>;
  isTransfer: Nullable<boolean>;
  isVoicemail: Nullable<boolean>;
  isSimulatedCall: Nullable<boolean>;
  sessionId: Nullable<string>;
  shouldRestartWorker: boolean;
  transferConsumerId: Nullable<string>;
  transferQuoteId: Nullable<string>;
  transferContractId: Nullable<number>;
  requestedOdometer: Nullable<number>;
}>;

export const INITIAL_SOFTPHONE_STATE = {
  agentStatus: AgentStatusEnum.Disconnected,
  callDirection: null,
  channel: null,
  connectionBehavior: SoftphoneConnectionBehaviorEnum.DoNotConnect,
  contactId: null,
  contactMasterId: null,
  contactPhoneNumber: null,
  leadId: null,
  isDialerReturn: null,
  isInternetResponder: null,
  isTvResponder: null,
  isSpanishSkillActive: null,
  isTransfer: null,
  isVoicemail: null,
  isSimulatedCall: false,
  sessionId: null,
  shouldRestartWorker: false,
  transferConsumerId: null,
  transferQuoteId: null,
  transferContractId: null,
  requestedOdometer: null,
} satisfies TSoftphoneState;

export const softphoneAtom = atom<TSoftphoneState>(INITIAL_SOFTPHONE_STATE);
